import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

const SmallIndicator = ({ children, color = 'black', bgcolor= 'transparent', borderColor = 'black' }) => (
    <Grid
        container
        color={color}
        bgcolor={bgcolor}
        border={'solid 1px'}
        borderColor={borderColor}
        sx={{ padding: 0.75, borderRadius: 2 }}
        alignItems={'center'}
        justifyContent={'center'}
        spacing={1}
    >
        {children}
    </Grid>
)

SmallIndicator.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    color: PropTypes.string,
    bgcolor: PropTypes.string,
    borderColor: PropTypes.string,
}

export default SmallIndicator